import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

const ListenerNotificationsTab = ({ testContent, onChangeTestContent, onSendEmail, onSendNotification, sendingEmail, sendingNotif }) => (
    <Row className="g-3">
        <Col md={12}>
            <Form.Group>
                <Form.Label>Test message content</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter message to send to this listener…"
                    value={testContent}
                    onChange={e => onChangeTestContent(e.target.value)}
                />
            </Form.Group>
        </Col>
        <Col md={12} className="d-flex gap-2 justify-content-center">
            <Button variant="outline-primary" onClick={onSendEmail} disabled={sendingEmail || !testContent.trim()}>
                {sendingEmail ? <><Spinner size="sm" animation="border" className="me-2" />Sending…</> : 'Send Test Email'}
            </Button>
            <Button variant="outline-info" onClick={onSendNotification} disabled={sendingNotif || !testContent.trim()}>
                {sendingNotif ? <><Spinner size="sm" animation="border" className="me-2" />Sending…</> : 'Send In-App Notification'}
            </Button>
        </Col>
    </Row>
);

export default ListenerNotificationsTab;
